import { EtiquetaController } from './etiqueta.controller';

export const EtiquetaComponent = {
  controller: EtiquetaController,
  require: {
    vmMain: '^appMain'
  },
  template: require('./etiqueta.html'),
};
